/**
 *
 * Scrollable
 *
 */

import React from 'react';
import classnames from 'classnames';

import LoadingOverlay from '~/components/LoadingOverlay';

import styles from './styles.module.css';

type ScrollableProps = {
  isLoading?: boolean;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  floatingActionButton?: React.ReactNode;
  className?: string;
};

const Scrollable = (props: ScrollableProps) => (
  <div className={styles.container}>
    {!!props.header && <div className={styles.header}>{props.header}</div>}
    <LoadingOverlay showProgress isLoading={props.isLoading || false}>
      <div className={classnames(styles.scrollable, props.className)}>
        {props.children}
      </div>
    </LoadingOverlay>
    {!!props.footer && <div className={styles.footer}>{props.footer}</div>}
    {!!props.floatingActionButton && (
      <div className={styles['floating-action-button']}>
        {props.floatingActionButton}
      </div>
    )}
  </div>
);

export default Scrollable;
